import React, { useState } from 'react';
import { FadeIn } from './ui';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Necesito comprar suplementos caros?',
  a: 'No, nos enfocamos en comida real que encuentras en cualquier supermercado.'
}, {
  q: '¿Puedo hacerlo si tengo hipotiroidismo?',
  a: 'Sí, este método ayuda a reducir la carga de estrés que suele agravar los problemas de tiroides.'
}, {
  q: '¿Es una dieta Keto?',
  a: 'No. Usamos carbohidratos de forma inteligente para proteger tu salud hormonal.'
}, {
  q: '¿Cuánto tiempo me tomará al día?',
  a: 'Solo el tiempo que ya usas para comer; es un cambio de orden y elección de alimentos.'
}, {
  q: '¿Recibiré un libro físico?',
  a: 'Es un producto 100% digital (PDF) para acceso inmediato en tu celular o tablet.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream py-20 px-6 md:py-28" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <FadeIn data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy text-center mb-12" data-id="element-26">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-27">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-28">
              <div className="bg-white rounded-2xl shadow-sm border border-sage/30 overflow-hidden" data-id="element-29">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-30">
                  <span className="text-lg font-bold text-navy pr-4" data-id="element-31">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-coral transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-32" />
                </button>
                <AnimatePresence data-id="element-33">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-34">
                      <div className="px-6 pb-5 text-gray-600 text-lg leading-relaxed border-t border-gray-100 pt-4" data-id="element-35">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}